module.exports = __webpack_public_path__ + "static/media/logo.23b3fdc2.svg";